// Mock data for George Venture Brands ecommerce site

export const BRAND = {
  name: "George Venture Brands",
  short: "GVB",
  tagline: "Elevate Your Physique. Feel The Difference.",
};

export const ANNOUNCEMENTS = [
  "30 Day Money Back Guarantee",
  "Free Shipping on orders over $50",
  "Premium Quality • Fast Shipping • Satisfaction Guaranteed",
];

export const NAV_LINKS = [
  { label: "Shop", href: "/collections" },
  { label: "Best Sellers", href: "/collections" },
  { label: "Rebounders", href: "/collections" },
  { label: "Our Story", href: "/about" },
  { label: "FAQ", href: "/faq" },
  { label: "Reviews", href: "/#reviews" },
];

export const PRESS_LOGOS = [
  { name: "VOGUE", style: "serif" },
  { name: "Women's Health", style: "sans" },
  { name: "Forbes", style: "serif-bold" },
  { name: "Harper's BAZAAR", style: "serif" },
  { name: "ELLE", style: "sans-bold" },
];

export const PRODUCTS = [
  {
    id: "gvb-55-hex-black",
    slug: "gvb-fit-55in-hexagon-black-rebounder",
    name: "GVB Fit 55in Hexagon Black Rebounder",
    shortDesc:
      "Meet your new partner for better cardio & health. The market leader in trampoline design, quality and bounce with over 25 years of engineering.",
    price: 399,
    compareAt: 599,
    rating: 4.7,
    reviews: 2840,
    badge: "Save $200.00",
    tag: "Best Seller",
    images: [
      "https://images.pexels.com/photos/6571945/pexels-photo-6571945.jpeg",
      "https://images.pexels.com/photos/6571939/pexels-photo-6571939.jpeg",
      "https://images.pexels.com/photos/5216305/pexels-photo-5216305.jpeg",
    ],
    features: [
      "Hexagonal design for maximum stability",
      "55-inch wide surface for dynamic movement",
      "Low-impact cardio that protects your joints",
      "Supports lymphatic drainage and circulation",
    ],
  },
  {
    id: "gvb-55-hex-white",
    slug: "gvb-fit-55in-hexagon-white-rebounder",
    name: "GVB Fit 55in Hexagon White Rebounder",
    shortDesc:
      "Meet your new partner for better cardio & health. The market leader in trampoline design, quality and bounce with over 25 years of engineering.",
    price: 399,
    compareAt: 599,
    rating: 4.7,
    reviews: 1980,
    badge: "Save $200.00",
    tag: "New",
    images: [
      "https://images.pexels.com/photos/6571939/pexels-photo-6571939.jpeg",
      "https://images.pexels.com/photos/5216305/pexels-photo-5216305.jpeg",
      "https://images.pexels.com/photos/6571945/pexels-photo-6571945.jpeg",
    ],
    features: [
      "Clean white frame fits any interior",
      "55-inch wide hexagonal jump surface",
      "Premium bungee bounce for quieter workouts",
      "Assembles in under 10 minutes",
    ],
  },
  {
    id: "gvb-44-round-black",
    slug: "gvb-fit-44in-round-black-rebounder",
    name: "GVB Fit 44in Round Black Rebounder",
    shortDesc:
      "A bounce engineered to give you a better workout and boost your cardio. GVB FIT is a fitness trampoline perfect for every home.",
    price: 359,
    compareAt: 499,
    rating: 4.7,
    reviews: 3210,
    badge: "Save $140.00",
    tag: "Popular",
    images: [
      "https://images.unsplash.com/photo-1606902965551-dce093cda6e7",
      "https://images.unsplash.com/photo-1774414489671-9f33b8dff0a9",
      "https://images.pexels.com/photos/5836973/pexels-photo-5836973.jpeg",
    ],
    features: [
      "Compact 44-inch round design",
      "Fits easily under couches and beds",
      "Holds up to 300 lbs of weight capacity",
      "Commercial-grade steel frame",
    ],
  },
  {
    id: "gvb-44-round-white",
    slug: "gvb-fit-44in-round-white-rebounder",
    name: "GVB Fit 44in Round White Rebounder",
    shortDesc:
      "A bounce engineered to give you a better workout and boost your cardio. GVB FIT is a fitness trampoline perfect for every home.",
    price: 359,
    compareAt: 499,
    rating: 4.7,
    reviews: 2275,
    badge: "Save $140.00",
    tag: "Staff Pick",
    images: [
      "https://images.unsplash.com/photo-1774414489812-f863c5bd32f4",
      "https://images.pexels.com/photos/29891529/pexels-photo-29891529.jpeg",
      "https://images.unsplash.com/photo-1634788699201-77bbb9428ab6",
    ],
    features: [
      "Minimalist white aesthetic",
      "Round 44-inch compact footprint",
      "Anti-slip foot pads for hardwood floors",
      "Lifetime frame warranty",
    ],
  },
];

export const MARQUEE_ITEMS = [
  "PREMIUM QUALITY",
  "FAST SHIPPING",
  "SATISFACTION GUARANTEED",
  "60-DAY MONEY BACK",
  "FREE RETURNS",
];

export const BEFORE_AFTER = {
  after: "https://images.pexels.com/photos/7991916/pexels-photo-7991916.jpeg",
  before: "https://images.pexels.com/photos/7991940/pexels-photo-7991940.jpeg",
};

export const INSTA_GRID = [
  "https://images.pexels.com/photos/6571945/pexels-photo-6571945.jpeg",
  "https://images.pexels.com/photos/6571939/pexels-photo-6571939.jpeg",
  "https://images.pexels.com/photos/5216305/pexels-photo-5216305.jpeg",
  "https://images.unsplash.com/photo-1606902965551-dce093cda6e7",
  "https://images.unsplash.com/photo-1774414489671-9f33b8dff0a9",
  "https://images.unsplash.com/photo-1774414489812-f863c5bd32f4",
  "https://images.pexels.com/photos/5836973/pexels-photo-5836973.jpeg",
  "https://images.pexels.com/photos/29891529/pexels-photo-29891529.jpeg",
  "https://images.unsplash.com/photo-1634788699201-77bbb9428ab6",
];

export const REVIEWS = [
  {
    id: 1,
    name: "Jessica",
    age: 32,
    verified: true,
    photo: "https://images.unsplash.com/photo-1606902965551-dce093cda6e7",
    body: "I got this for my mom and she loves it. At 66 years old she was tired of treadmills and aerobic videos. It all became so boring. She still loves her weight lifting but needed more for changing up her activity level. Mini trampolines are so FUN to use. She looks forward to her mini workouts all day long. Great mood lifter!",
    product: "GVB Fit 55in Hexagon Black Rebounder",
    productImage: "https://images.pexels.com/photos/6571945/pexels-photo-6571945.jpeg",
    price: 399,
    compareAt: 599,
    date: "Purchased on June 21, 2025",
  },
  {
    id: 2,
    name: "Olivia",
    age: 41,
    verified: true,
    photo: "https://images.unsplash.com/photo-1774414489671-9f33b8dff0a9",
    body: "I bought this rebounder to be able to do some bouncing workout videos. It has a nice bounce. Feels very sturdy. I've used it in my living room and on my wooden deck outside. I've been using it for about a year and it still feels tight and bouncy. Great rebounder for a cheaper price than the big name brands. I'm glad I went with George Venture Brands.",
    product: "GVB Fit 55in Hexagon Black Rebounder",
    productImage: "https://images.pexels.com/photos/6571945/pexels-photo-6571945.jpeg",
    price: 399,
    compareAt: 599,
    date: "Purchased on February 13, 2025",
  },
  {
    id: 3,
    name: "Allie",
    age: 35,
    verified: true,
    photo: "https://images.unsplash.com/photo-1774414489812-f863c5bd32f4",
    body: "If you only buy one thing for yourself this year make it this rebounder! I researched for weeks before settling on this one and I am not disappointed. I use it several times a day. The cords on the rebounder are gentle on the knees and a quick workout is the equivalent of a 30 minute run. It improves overall fitness and is a great workout!",
    product: "GVB Fit 44in Round Black Rebounder",
    productImage: "https://images.unsplash.com/photo-1606902965551-dce093cda6e7",
    price: 359,
    compareAt: 499,
    date: "Purchased on March 14, 2025",
  },
  {
    id: 4,
    name: "Priya",
    age: 29,
    verified: true,
    photo: "https://images.pexels.com/photos/5836973/pexels-photo-5836973.jpeg",
    body: "Love how compact this is. I live in a small apartment and this fits perfectly in the corner of my living room. The bounce is fantastic and I genuinely look forward to my daily workouts now. Customer service was also amazing when I had a question about assembly.",
    product: "GVB Fit 44in Round White Rebounder",
    productImage: "https://images.unsplash.com/photo-1774414489812-f863c5bd32f4",
    price: 359,
    compareAt: 499,
    date: "Purchased on April 2, 2025",
  },
];

export const FOOTER_LINKS = {
  Shop: ["Best Sellers", "Rebounders", "Accessories", "Bundles", "Gift Cards"],
  Support: [
    "Contact Us",
    "Shipping Policy",
    "Returns & Refunds",
    "Track Order",
    "FAQ",
  ],
  Company: ["Our Story", "Press", "Ambassadors", "Careers", "Affiliate Program"],
  Legal: ["Terms of Service", "Privacy Policy", "Accessibility", "Cookie Policy"],
};
